import React from 'react';
import './SizeGuide.css';

const backArrow = "https://cdn.obsessvr.com/next-thumbnail-arrow.png";



const SizeGuide = ({ onClose, setShowSizeGuide }) => {

  

    const renderARFeature = () => {
        return <div className="product-ar-iframe">
            <iframe src={`https://docs.google.com/gview?url=https://cdn.obsess-vr.com/ferragamo/SIZE_GUIDE_SHOES_RTW_V2.pdf?toolbar=0&view=fitH&embedded=true`} style={{ width: '100%', height: '100%'}} frameBorder="0" zoom='0.75'></iframe>
        </div>
    }
    return (
        <div className='product-ar-body-wrapper'>
            <div className='backButton' onClick={() => setShowSizeGuide(false)}>
                <img src={backArrow} alt="back-arrow" />
            </div>
            <div className="product-ar-body">
                {renderARFeature()}
            </div>
        </div>
    )
}

export default SizeGuide;
